import React, { FunctionComponent } from "react";

import { useSearchWheelsByVehicle } from "../../../queries/useSearchWheelsByVehicle";
import { FiltersPanel } from "../../FiltersSidebar/FiltersPanel";
import { TireSizeFilters } from "../../Tires/Results/Filters/TireSizeFilters/TireSizeFilters";
import { WheelBrand } from "./WheelBrands/WheelBrands";
import { WheelPrice } from "./WheelPrice/WheelPrice";

export const WheelsFilters: FunctionComponent<{ onClose(): void }> = ({
  onClose,
}) => {
  const { isLoading } = useSearchWheelsByVehicle({
    keepPreviousData: true,
  });
  return (
    <FiltersPanel loading={isLoading} onClose={onClose}>
      <TireSizeFilters />
      <WheelBrand />
      <WheelPrice />
    </FiltersPanel>
  );
};
